import React, { useEffect, useState, useRef } from "react";
import * as c from "./fadeInOnFontLoad.module.scss";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";

const FONT_LOADED_KEY = "mm-font-loaded";

const FadeInOnFontLoad = ({ children }) => {
  const [isFontLoaded, setIsFontLoaded] = useState(false);

  useEffect(() => {
    const done = () => {
      localStorage.setItem(FONT_LOADED_KEY, "1");
      setIsFontLoaded(true);
    };

    // Skip overlay on return visits where font was already loaded
    if (localStorage.getItem(FONT_LOADED_KEY)) {
      setIsFontLoaded(true);
      return;
    }

    // Font already in browser cache — no need to wait
    if (document.fonts.check("1em tt-commons-pro")) {
      done();
      return;
    }

    // Timeout after 1 second — show page with fallback font rather than blank screen
    const timeoutId = setTimeout(done, 1000);

    // Wait for just tt-commons-pro, not all fonts on the page
    document.fonts
      .load("1em tt-commons-pro")
      .then(() => {
        clearTimeout(timeoutId);
        done();
      })
      .catch(() => {
        clearTimeout(timeoutId);
        done();
      });

    return () => clearTimeout(timeoutId);
  }, []);

  const ref = useRef(null);

  const pageTransitionDelay = 4 / 30; // Delay slightly to allow browser more time to load content
  const pageTransitionDuration = 6 / 30 + pageTransitionDelay;

  useGSAP(() => {
    if (isFontLoaded) {
      gsap.to(ref.current, { opacity: 0, duration: pageTransitionDuration, delay: pageTransitionDelay });
      gsap.to(ref.current, {
        zIndex: -99999,
        pointerEvents: "none",
        display: "none",
        visibility: "hidden",
        duration: 1 / 30,
        delay: pageTransitionDuration,
      });
    }
  }, [isFontLoaded]);

  return (
    <>
      <div ref={ref} className={c.overlay}></div>
      {children}
    </>
  );
};

export default FadeInOnFontLoad;
